import type { TuitionSubject } from '../tuitionSubjects/tuitionSubjects.js';

export const BLOG_CATEGORIES = [
  'Primary Math',
  'Secondary Math',
  'Choosing Math Tuition',
  'Learning & Mindset',
  'Secondary English',
  'Secondary Chemistry',
] as const;
export type BlogCategory = (typeof BLOG_CATEGORIES)[number];

export function getBlogTuitionSubject(category: string): TuitionSubject {
  if (category === 'Secondary English') return 'english';
  if (category === 'Secondary Chemistry') return 'chemistry';
  return 'mathematics';
}
